import React from 'react';
import './index.scss';
import Icon from './Icon';

export const AddRemoveButtons = ({
  className,
  quantity,
  disabled,
  onQuantityChange,
  maxQuantity
}) => {
  const buttonClassName = [className, 'btn--quantity']
    .filter(Boolean)
    .join(' ');

  const handleDecrement = () => {
    if (disabled || !onQuantityChange || typeof onQuantityChange !== 'function')
      return;

    onQuantityChange(Math.max(0, quantity - 1));
  };

  const handleIncrement = () => {
    if (disabled || !onQuantityChange) return;

    if (
      (maxQuantity !== undefined && quantity >= maxQuantity) ||
      typeof onQuantityChange !== 'function'
    ) {
      return;
    }

    onQuantityChange(quantity + 1);
  };
  return (
    <div className={buttonClassName} aria-label={`Quantity: ${quantity}`}>
      <button
        type="button"
        className="btn-quantity__action"
        onClick={handleDecrement}
        disabled={disabled || !onQuantityChange}
        aria-label="Decrease quantity"
      >
        <span aria-hidden="true">
          <Icon name="minus" stokeWidth={3} />
        </span>
      </button>

      <span
        className="btn-quantity__value"
        aria-live="polite"
        aria-atomic="true"
      >
        {quantity}
      </span>

      <button
        type="button"
        className="btn-quantity__action"
        onClick={handleIncrement}
        disabled={
          disabled ||
          !onQuantityChange ||
          (maxQuantity !== undefined && quantity >= maxQuantity)
        }
        aria-label="Increase quantity"
      >
        <span aria-hidden="true">
          <Icon name="plus" stokeWidth={3} />
        </span>
      </button>
    </div>
  );
};

const MealButton = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  className = '',
  startIcon,
  endIcon,
  disabled = false,
  quantity = 0,
  onQuantityChange,
  maxQuantity,
  ...props
}) => {
  const isQuantityMode = quantity > 0 && !loading;

  const buttonClassName = ['btn', `btn-${variant}`, `btn-${size}`, className]
    .filter(Boolean)
    .join(' ');

  if (isQuantityMode) {
    return (
      <AddRemoveButtons
        className={buttonClassName}
        disabled={disabled}
        maxQuantity={maxQuantity}
        onQuantityChange={onQuantityChange}
        quantity={quantity}
      />
      // <div
      //   className={`${buttonClassName} btn--quantity`}
      //   aria-label={`Quantity: ${quantity}`}
      // >
      //   <button
      //     type="button"
      //     className="btn-quantity__action"
      //     onClick={handleDecrement}
      //     disabled={disabled || !onQuantityChange}
      //     aria-label="Decrease quantity"
      //   >
      //     <span aria-hidden="true">
      //       <Icon name="minus" stokeWidth={3} />
      //     </span>
      //   </button>

      //   <span
      //     className="btn-quantity__value"
      //     aria-live="polite"
      //     aria-atomic="true"
      //   >
      //     {quantity}
      //   </span>

      //   <button
      //     type="button"
      //     className="btn-quantity__action"
      //     onClick={handleIncrement}
      //     disabled={
      //       disabled ||
      //       !onQuantityChange ||
      //       (maxQuantity !== undefined && quantity >= maxQuantity)
      //     }
      //     aria-label="Increase quantity"
      //   >
      //     <span aria-hidden="true">
      //       <Icon name="plus" stokeWidth={3} />
      //     </span>
      //   </button>
      // </div>
    );
  }

  return (
    <button
      type="button"
      className={buttonClassName}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="btn__loader" />
      ) : (
        <>
          {startIcon && (
            <span className="btn__icon btn__icon--start">{startIcon}</span>
          )}

          <span className="btn__text">{children}</span>

          {endIcon && (
            <span className="btn__icon btn__icon--end">{endIcon}</span>
          )}
        </>
      )}
    </button>
  );
};

export default MealButton;
